module.exports = __webpack_public_path__ + "fonts/element-icons.535877f5.535877f5.woff";